import React, { useState } from 'react';
import { CARS } from '../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { stockCarsOptions } from '../../constants/filterOptions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setFilters } from '../../utils/setFilters';
import describeFilters from '../../utils/describeFilters';
import { parseTableQuery, buildTableQuery } from '../../utils/tableQuery';
import { sortCarsParams } from '../../constants/sortParams';

// components
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';
import HookForm from '../../components/HookForm/HookForm';

// icons
import icon from '../../brand/generated/sidebar/cars.svg';
import getItems from '../../api/cars/getItems';
import getStockFilters from '../../api/cars/getStockFilters';
import bucketIcon from '../../brand/generated/popover/delete.svg';
import { PERMISSION_CAN_DELETE_DEALS, PERMISSION_CAN_EDIT_AUTO_AND_EQUIPMENTS } from '../../constants/roles';
import isUserHavePermission from '../../utils/isUserHavePermission';
import alert from '../../helpers/alert';
import removeCar from '../../api/cars/removeCar';
import extractErrorMessage from '../../utils/extractErrorMessage';

const tableStyle = { backgroundColor: 'white' };

// Ð­ÑÐ° ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð²ÑÐµÐ³Ð´Ð° Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾Ðº (forApp=true + Ð°ÐºÑÐ¸Ð²Ð½Ð°Ñ
// Ð·Ð°Ð¿Ð¸ÑÑ Ð² dealers_stock) â ÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ, ÑÑÐ¾ Ð´ÐµÐ»Ð°ÐµÑ Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ðµ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¸
// Ð¿Ð¾ÐºÐ°Ð·Ðµ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°. ÐÐ¼ÐµÐ½Ð½Ð¾ Ð¿Ð¾ÑÑÐ¾Ð¼Ñ STOCK_SCOPE Ð½Ðµ Ð¸Ð´ÑÑ ÑÐµÑÐµÐ· defaultQueryParams
// ÐºÐ°Ðº Ð² pages/Car/Cars.jsx: ÑÐ°Ð¼ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ/ÑÐ±ÑÐ¾Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð² ÑÐµÑÐµÐ· TableTabs
// Ð¿Ð¾Ð»Ð½Ð¾ÑÑÑÑ Ð·Ð°Ð¼ÐµÐ½ÑÐµÑ queryParams (ÑÐ¼. utils/setFilters.js), ÑÑÐ¾ ÑÑÑÑÐ»Ð¾ Ð±Ñ ÑÑÑ
// Ð¾Ð±Ð»Ð°ÑÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÐ¸. ÐÐ¼ÐµÑÑÐ¾ ÑÑÐ¾Ð³Ð¾ STOCK_SCOPE Ð²ÑÐµÐ³Ð´Ð° Ð´Ð¾Ð¼ÐµÑÐ¸Ð²Ð°ÐµÑÑÑ Ð² Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ
// Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¼ â ÑÐ¶Ðµ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð² â Ð¸ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ
// ÑÐ»ÑÑÐ°Ð¹Ð½Ð¾ ÑÐ½ÑÑ ÑÐµÑÐµÐ· "Ð Ð°ÑÑÐ¸ÑÐµÐ½Ð½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº"/"Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ Ð²ÑÐµ"
const STOCK_SCOPE = { forApp: true, stock: true };

let sortCount = 1;

const FILTER_NAMES = [...stockCarsOptions.map((option) => option.name), 'all'];

const StockCars = () => {
  const [columns, setColumns] = React.useState(CARS);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // Ð Ð°Ð·Ð±Ð¸ÑÐ°ÐµÐ¼ Ð°Ð´ÑÐµÑ Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·: Ð´Ð°Ð»ÑÑÐµ Ð°Ð´ÑÐµÑ Ð¿Ð¸ÑÐµÐ¼ Ð¼Ñ ÑÐ°Ð¼Ð¸, Ð¸ Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÑÑ ÐµÐ³Ð¾
  // Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ Ð·Ð½Ð°ÑÐ¸Ð»Ð¾ Ð±Ñ Ð³Ð¾Ð½ÑÑÑÑÑ Ð·Ð° ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÑÑ.
  const fromUrl = React.useRef(parseTableQuery(searchParams, FILTER_NAMES)).current;
  const [loading, setLoading] = useState(true);
  const [cars, setCars] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [pagination, setPagination] = useState({
    page: fromUrl.page,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: fromUrl.pageSize || 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);

  const table = useTable(
    {
      columns,
      data: cars,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page, setPageSize } = table;

  const [value, setValue] = useState(fromUrl.filters.all || '');
  const [queryParams, setQueryParams] = useState(fromUrl.filters);
  const [appliedFilters, setAppliedFilters] = useState([]);
  // ÐÐ°ÑÐ¸Ð°Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð² ÑÐ¾ ÑÑÑÑÑÐ¸ÐºÐ°Ð¼Ð¸; ÐºÐ»Ð°Ð´ÑÐ¼ Ð¸Ñ Ð¿ÑÑÐ¼Ð¾ Ð² Ð¾Ð¿ÑÐ¸Ð¸ ÑÐ¾ÑÐ¼Ñ â HookForm
  // ÑÐ¿ÑÐµÐ´Ð¸Ñ Ð¾Ð±ÑÐµÐºÑ Ð¾Ð¿ÑÐ¸Ð¸ Ð½Ð° ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ, ÑÐ°Ðº ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ»ÐµÐºÑ Ð¿Ð¾Ð»ÑÑÐ°ÐµÑ ÑÐ²Ð¾Ð¹ ÑÐ¿Ð¸ÑÐ¾Ðº.
  const [facets, setFacets] = useState({});
  const filtersFormRef = React.useRef(null);
  const filtersTimer = React.useRef(null);
  const lastCityRef = React.useRef(fromUrl.filters.cityId ? Number(fromUrl.filters.cityId) : null);
  // ÐÐ¾ÐºÐ° ÑÐ°ÑÐºÐ»Ð°Ð´ÑÐ²Ð°ÐµÐ¼ ÑÐ¸Ð»ÑÑÑÑ Ð¸Ð· Ð°Ð´ÑÐµÑÐ° Ð¾Ð±ÑÐ°ÑÐ½Ð¾ Ð² ÑÐ¾ÑÐ¼Ñ, ÐµÑ Ð¶Ðµ ÑÐ¾Ð±ÑÑÐ¸Ñ Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÑÐµÐ¼:
  // Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð¸ ÑÐ±ÑÐ¾ÑÐ¸Ð»Ð¸ Ð±Ñ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð½Ð° Ð¿ÐµÑÐ²ÑÑ.
  const restoringRef = React.useRef(false);
  const restoredRef = React.useRef(false);

  stockCarsOptions.forEach((option) => {
    option.options = facets[option.name] || [];
  });

  const handleNavigate = (index) => {
    if (!isUserHavePermission(PERMISSION_CAN_EDIT_AUTO_AND_EQUIPMENTS)) {
      return;
    }
    navigate(`/cars/car/${index}/main-data`, { state: cars.find((item) => item.id === index) });
  };

  const init = async (page) => {
    setLoading(true);
    await getItems({ ...page, ...STOCK_SCOPE })
      .then((res) => {
        setCars(res.data.cars);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
        setDataCount(res.data.pagination?.count);
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    if (!isFetchAll) {
      init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);

  // Ð¤Ð¸Ð»ÑÑÑÑ Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð¶Ð¸Ð²ÑÑ Ð² Ð°Ð´ÑÐµÑÐµ: ÑÑÑÐ» Ð² ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¼Ð°ÑÐ¸Ð½Ñ, Ð²ÐµÑÐ½ÑÐ»ÑÑ Ð½Ð°Ð·Ð°Ð´ â
  // ÑÐ¿Ð¸ÑÐ¾Ðº Ð¾ÑÐºÑÑÐ»ÑÑ ÑÐ¾Ð²Ð½Ð¾ ÑÐ°Ð¼ Ð¶Ðµ. replace, Ð° Ð½Ðµ push: Ð¸Ð½Ð°ÑÐµ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð¿ÑÐ¸ÑÐ»Ð¾ÑÑ Ð±Ñ
  // Ð¶Ð°ÑÑ ÑÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð·, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾Ð»ÐµÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾ÑÑÐ¾Ð³Ð°Ð».
  React.useEffect(() => {
    setSearchParams(buildTableQuery(queryParams, pagination.page, pagination.pageSize), {
      replace: true,
    });
  }, [queryParams, pagination.page, pagination.pageSize]);

  // Ð¡Ð¿Ð¸ÑÐºÐ¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ Ð¿ÐµÑÐµÑÑÐ¸ÑÑÐ²Ð°ÑÑÑÑ Ð¿Ð¾Ð´ ÑÐµÐºÑÑÐ¸Ð¹ ÑÐ¸Ð»ÑÑÑ: Ð²ÑÐ±ÑÐ°Ð»Ð¸ Ð³Ð¾ÑÐ¾Ð´ â Ð² Â«ÐÐ¦Â»
  // Ð¾ÑÑÐ°ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐµÐ³Ð¾ ÑÐµÐ½ÑÑÑ, Ð¸ Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ° Ð²Ð¸Ð´Ð½Ð¾, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÑÐ¸Ð½ Ð±ÑÐ´ÐµÑ.
  React.useEffect(() => {
    getStockFilters({ ...queryParams, ...STOCK_SCOPE })
      .then((res) => setFacets(res?.data || {}))
      .catch(() => {});
  }, [queryParams]);

  const applyFilters = (resetFilters) => {
    clearTimeout(filtersTimer.current);
    if (resetFilters) {
      lastCityRef.current = null;
      // ÐÐ½Ð°ÑÐµ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¸Ð· Ð°Ð´ÑÐµÑÐ° Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²ÐµÑÐ½ÑÐ»Ð¸ÑÑ Ð±Ñ Ð¿ÑÐ¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼
      // Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð¿Ð°Ð½ÐµÐ»Ð¸: ÑÐ¾ÑÐ¼Ð° Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¸Ð· defaultValue.
      stockCarsOptions.forEach((option) => delete option.defaultValue);
    }
    setFilters(resetFilters, setFetchAll, setPageSize, setPagination, setQueryParams, stockCarsOptions);
    setAppliedFilters(resetFilters ? [] : describeFilters(stockCarsOptions));
  };

  // Ð¤Ð¸Ð»ÑÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐµÑÑÑ ÑÐ°Ð¼, Ð±ÐµÐ· ÐºÐ½Ð¾Ð¿ÐºÐ¸; Ð·Ð°Ð´ÐµÑÐ¶ÐºÐ° Ð³Ð°ÑÐ¸Ñ Ð»Ð¸ÑÐ½Ð¸Ðµ Ð·Ð°Ð¿ÑÐ¾ÑÑ, Ð¿Ð¾ÐºÐ°
  // Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÑÐ»ÐºÐ°ÐµÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾Ð»ÐµÐ¹ Ð¿Ð¾Ð´ÑÑÐ´.
  const handleFiltersChange = React.useCallback((values) => {
    if (restoringRef.current) return;
    // Ð¡Ð¼ÐµÐ½Ð¸Ð»Ð¸ Ð³Ð¾ÑÐ¾Ð´ â ÐÐ¦ Ð¸Ð· Ð¿ÑÐµÐ¶Ð½ÐµÐ³Ð¾ Ð³Ð¾ÑÐ¾Ð´Ð° Ð´Ð°Ð» Ð±Ñ Ð¿ÑÑÑÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ, ÑÐ½Ð¸Ð¼Ð°ÐµÐ¼ ÐµÐ³Ð¾.
    const cityId = values?.cityId?.value ?? null;
    if (cityId !== lastCityRef.current) {
      lastCityRef.current = cityId;
      if (values?.dcId) {
        const dc = stockCarsOptions.find((item) => item.name === 'dcId');
        if (dc) {
          delete dc.value;
          delete dc.defaultValue;
        }
        filtersFormRef.current?.setValue('dcId', null);
      }
    }

    clearTimeout(filtersTimer.current);
    filtersTimer.current = setTimeout(() => applyFilters(false), 400);
  }, []);

  React.useEffect(() => () => clearTimeout(filtersTimer.current), []);

  // ÐÐ¾Ð´Ð¿Ð¸ÑÐ¸ Ð´Ð»Ñ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ Ð¸Ð· Ð°Ð´ÑÐµÑÐ° Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐ°ÑÐµÑÐ¾Ð²: Ð² URL Ð»ÐµÐ¶Ð¸Ñ ÑÐ¾Ð»ÑÐºÐ¾ id.
  React.useEffect(() => {
    if (restoredRef.current || !Object.keys(facets).length) return;
    restoredRef.current = true;

    restoringRef.current = true;
    stockCarsOptions.forEach((option) => {
      const raw = fromUrl.filters[option.name];
      if (raw === undefined) return;
      const known = (facets[option.name] || []).find((item) => String(item.value) === String(raw));
      const restored = known
        ? { value: known.value, label: known.label }
        : { value: raw, label: String(raw) };
      option.value = restored;
      // defaultValue, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ setValue: Ð¿Ð°Ð½ÐµÐ»Ñ Ð¼Ð¾Ð³Ð»Ð¸ ÐµÑÑ Ð½Ðµ ÑÐ°ÑÐºÑÑÑÑ, Ð¸ ÑÐ¾Ð³Ð´Ð°
      // ÑÐ¾ÑÐ¼Ð° ÑÐ¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¿Ð¾Ð·Ð¶Ðµ â Ð½Ð° Ð¿ÑÑÑÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸ÑÑ, Ð·Ð°ÑÐµÑÐµÐ² Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐµ.
      option.defaultValue = restored;
      filtersFormRef.current?.setValue(option.name, restored);
    });
    setAppliedFilters(describeFilters(stockCarsOptions));
    restoringRef.current = false;
  }, [facets]);

  const removeFilter = (name) => {
    const option = stockCarsOptions.find((item) => item.name === name);
    if (option) {
      delete option.value;
      delete option.defaultValue;
    }
    filtersFormRef.current?.setValue(name, null);
    applyFilters(false);
  };

  const handleActionPopover = async (carIndex, actionIndex, title, id) => {};

  const sortBy = (value) => {
    queryParams.sortBy = sortCarsParams.get(value);
    if (!sortCarsParams.get(value) || (sortCount > 1 && sortCarsParams.get(value) !== queryParams.sortBy)) {
      sortCount = 1;
      return;
    }
    if (sortCount === 3) {
      sortCount = 1;
    }
    if (sortCarsParams.get(value) === queryParams.sortBy && sortCount === 1) {
      queryParams.sortBy = sortCarsParams.get(value);
      queryParams.sort = 'ask';
      sortCount++;
    } else if (sortCarsParams.get(value) === queryParams.sortBy && sortCount === 2) {
      queryParams.sortBy = sortCarsParams.get(value);
      queryParams.sort = 'desc';
      sortCount++;
    }
    setFetchAll(false);
    setQueryParams({ ...queryParams });
  };

  const popover = [
    {
      title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
      icon: bucketIcon,
      onClick: async (row) => {
        removeCar({ id: row?.id })
          .then(() => {
            init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
          })
          .catch((err) => {
            alert.error(extractErrorMessage(err?.response?.data) || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');
          });
      },
      permission: PERMISSION_CAN_DELETE_DEALS,
    },
  ];

  const onFastSearch = (value) => {
    setPagination({
      ...pagination,
      page: 1,
    });

    setQueryParams({
      ...queryParams,
      all: value,
    });
  };

  return (
    <>
      <Header title="Ð¡ÑÐ¾Ðº Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹" icon={icon} />
      <br />
      <br />
      <br />
      <br />
      <TableTabs
        setFilter={onFastSearch}
        value={value}
        setValue={setValue}
        filterComponent={
          <HookForm
            ref={filtersFormRef}
            inputs={stockCarsOptions}
            onValuesChange={handleFiltersChange}
            grid={{
              display: 'grid',
              gap: '10px',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
            }}
            responsiveForm
            style={{ backgroundColor: 'transparent' }}
          />
        }
        defaultFiltersOpen={Object.keys(fromUrl.filters).some((name) => name !== 'all')}
        handleSearchParams={applyFilters}
        appliedFilters={appliedFilters}
        onRemoveFilter={removeFilter}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ ÑÑÐ¾ÐºÐ¾Ð²ÑÐ¼ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÐ¼'}
        // ÐÐ½Ð¾Ð¿ÐºÐ¸ "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ" ÑÑÑ Ð½ÐµÑ â ÑÑÐ¾ÐºÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÑÑ Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³ ÑÐ¾Ð»ÑÐºÐ¾
        // ÑÐµÑÐµÐ· Ð·Ð°Ð³ÑÑÐ·ÐºÑ ÑÐ°Ð¹Ð»Ð° Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ "ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÑÐ¾ÐºÐ°", Ð½Ðµ Ð²ÑÑÑÐ½ÑÑ Ð¾ÑÑÑÐ´Ð°.
        // permission Ð½Ð° Ð·Ð°Ð²ÐµÐ´Ð¾Ð¼Ð¾ Ð½ÐµÑÑÑÐµÑÑÐ²ÑÑÑÐµÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ â ÑÐºÑÑÐ²Ð°ÐµÑ Ð¿ÑÑÑÑÑ
        // IconButton, ÐºÐ¾ÑÐ¾ÑÑÑ TableTabs Ð¸Ð½Ð°ÑÐµ ÑÐµÐ½Ð´ÐµÑÐ¸Ñ Ð²ÑÐµÐ³Ð´Ð° (permission Ð¿Ð¾
        // ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ 'all')
        permission="__none__"
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <Table
          table={table}
          all={'Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹'}
          style={tableStyle}
          handleNavigate={handleNavigate}
          pagination
          sort
          setPagination={setPagination}
          setFetchAll={setFetchAll}
          isFetchAll={isFetchAll}
          setData={setCars}
          p={pagination}
          loading={loading}
          setLoading={setLoading}
          columns={columns}
          setColumns={setColumns}
          columnsSettingsKey="stockCars"
          queryParams={{ ...queryParams, ...STOCK_SCOPE }}
          api={'/api/shop/getItems'}
          response={'cars'}
          popover={popover}
          handleActionPopover={handleActionPopover}
          dataCount={dataCount}
          handleSortTable={sortBy}
        />
      )}
    </>
  );
};

export default StockCars;
